import { SOLAR } from "@/constants/testIds";
import { BTN_OUTLINE } from "@/components/solar/ui";

interface Props {
  onLocation: (lat: number, lon: number) => void;
  onError: (message: string) => void;
}

export default function MyLocationButton({ onLocation, onError }: Props) {
  const locate = () => {
    if (!("geolocation" in navigator)) {
      onError("Geolocation is not supported by this browser.");
      return;
    }
    onError("");
    navigator.geolocation.getCurrentPosition(
      (pos) => onLocation(pos.coords.latitude, pos.coords.longitude),
      (err) => onError(`Could not get location: ${err.message}`),
      { enableHighAccuracy: false, timeout: 10_000 },
    );
  };
  return (
    <button data-testid={SOLAR.useLocationBtn} onClick={locate} className={BTN_OUTLINE}>
      Use my location
    </button>
  );
}
